import { InboxView, ThreadReadStatus } from '@weave/schema-gen-ts/dist/schemas/sms/data/v4/sms_service.pb';
import { CountThreadsStatusUpdate } from '../../../types';
import { CountThreadsIO } from '../../types';

export const getCountModifier = (
  request: Partial<CountThreadsIO['input']>,
  newStatus: CountThreadsStatusUpdate
): 'add' | 'subtract' | 'none' => {
  switch (newStatus) {
    case 'actionable':
    case 'not-actionable':
      if (request.filter?.inboxView === InboxView.ACTIONABLE) return newStatus === 'actionable' ? 'add' : 'subtract';
      else return 'none';
    case 'read':
    case 'error':
      if (
        request.filter?.statuses?.includes(ThreadReadStatus.READ) &&
        !request.filter?.statuses?.includes(ThreadReadStatus.NEW)
      ) {
        return 'add';
      } else if (
        request.filter?.statuses?.includes(ThreadReadStatus.NEW) &&
        !request.filter.statuses?.includes(ThreadReadStatus.READ)
      ) {
        return 'subtract';
      }
      return 'none';
    case 'unread':
      if (
        request.filter?.statuses?.includes(ThreadReadStatus.READ) &&
        !request.filter?.statuses?.includes(ThreadReadStatus.NEW)
      ) {
        return 'subtract';
      } else if (
        request.filter?.statuses?.includes(ThreadReadStatus.NEW) &&
        !request.filter.statuses?.includes(ThreadReadStatus.READ)
      ) {
        return 'add';
      }
      return 'none';
    default:
      return 'none';
  }
};
